const profileStatus = {
  accept: 'accept',
  reject: 'reject',
};

export default profileStatus;
